import 'bootstrap'
import "core-js/stable"
import "regenerator-runtime/runtime"
import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
if(pathIs('/app*')) {
    axios.defaults.headers.common['IN_APP'] = true;
}

import './moment.phpDateFormat';
import 'masonry-layout';
import 'datatables.net-responsive-bs4';
import './datatables';
import './jquery.fittext';

import './utilities';
import './confirmModal';
import './toastAlert';
import './forms';
import './spinner';
import './tables';
import './stackable-modals';

(function (global) {
    global.$ = $;
    global.jQuery = jQuery;
    global.bootstrap = bootstrap;
}(typeof window !== 'undefined' ? window : this));

// Admin panel
import './admin';

import './error-info';

// App
import './app/index'
import {Fancybox} from "../js/jquery.fancybox";

// Universal
import './universal'
import {pathIs} from "./utilities";
import './session-alert';
import './shp';

const body = $('body');

let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {trigger: 'hover'})
})

body.on('click', '[data-bs-toggle="tooltip"]', function () {
    $(this).tooltip('hide')
})

body.on('click', '.popover', function (e) {
    e.stopPropagation();
});


$("#check-all").click(function(){
    $('input:checkbox').not(this).prop('checked', this.checked);
});

export const in_app = () => {
    return pathIs('/app*');
}

// lightbox thumbnails
Fancybox.bind('[data-app-thumbnail]', {
    Toolbar: {
        display: ["download", "zoom", "fullscreen", "close"],
    }
})